<template>
    <b-col lg="10">
      <b-card :title="title" border-variant="white">
        <b-card-text class="text-left" v-html="text">
        </b-card-text>
      </b-card>
    </b-col>
</template>

<script>
export default {
  name: 'FormExplanation',
  props: {
    text: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
  button, [type="button"] {
    -webkit-appearance: button;
    height: 28px;
    width: 28px !important;
    padding: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/FormExplanation.vue